import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Description } from '../description/description.js';
import { useIdProvider, getDescriptionId } from '../hooks/id-provider.js';
import { ManuallyLabeledSwitch } from './manually-labeled-switch.js';
import { root, description } from './switch.css.js';

/**
 * Represents a physical toggle to turn a setting “on” or “off”.
 * @note Unlike checkboxes, toggling a switch should take immediate effect without a need for additional confirmation steps
 * @see https://fpl.figma.design/components/switch/
 */
const Switch = forwardRef(({ label, children, ...props }, ref) => {
    const hasDescription = !!children;
    const [id, Provider] = useIdProvider();
    const descriptionId = hasDescription ? getDescriptionId(id) : undefined;
    return (jsx(Provider, { value: id, children: jsxs("div", { className: root, children: [jsx(ManuallyLabeledSwitch, { ...props, id: id, ref: ref, "aria-describedby": descriptionId }), label, hasDescription && jsx(Description, { className: description, children: children })] }) }));
});
Switch.displayName = 'Switch';

export { Switch };
//# sourceMappingURL=switch.js.map
